import { c as _c } from "react/compiler-runtime";
import React from "react";
import { TrialSummary } from "trimble-terra";
import { CognitoFormComponent } from "../trials/CognitoFormComponent";
interface EntitlementsFormProps {
  trialSummary: any;
  cognitoForm: {
    formId: string;
    id?: string;
    header?: string;
    description?: string;
    name?: string;
  };
  appData: any;
  userInfo: any;
  productData: {
    sku: string;
    trialDuration?: number;
  };
  prefillData: Record<string, string>;
  startTrial: (setLoading: React.Dispatch<React.SetStateAction<boolean>>, setError: React.Dispatch<React.SetStateAction<boolean>>, setErrorText: React.Dispatch<React.SetStateAction<string>>, sku?: string, accessToken?: string | null) => void;
  accessToken?: string | null;
  setLoading: React.Dispatch<React.SetStateAction<boolean>>;
  setError: React.Dispatch<React.SetStateAction<boolean>>;
  setErrorText: React.Dispatch<React.SetStateAction<string>>;
  loading: boolean;
  partnerPage: boolean;
  trialIdFromAPI?: string;
}
const EntitlementsForm: React.FC<EntitlementsFormProps> = t0 => {
  const $ = _c(25);
  const {
    trialSummary,
    cognitoForm,
    productData,
    prefillData,
    startTrial,
    accessToken,
    setLoading,
    setError,
    setErrorText,
    loading,
    partnerPage,
    trialIdFromAPI
  } = t0;
  let t1;
  if ($[0] !== cognitoForm?.header) {
    t1 = cognitoForm?.header && <h2 className="entitlement-form-container--header">{cognitoForm?.header}</h2>;
    $[0] = cognitoForm?.header;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== cognitoForm?.description) {
    t2 = cognitoForm?.description && <p className="entitlement-form-container--description">{cognitoForm?.description}</p>;
    $[2] = cognitoForm?.description;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== accessToken || $[5] !== cognitoForm || $[6] !== loading || $[7] !== partnerPage || $[8] !== prefillData || $[9] !== productData || $[10] !== setError || $[11] !== setErrorText || $[12] !== setLoading || $[13] !== startTrial || $[14] !== trialIdFromAPI) {
    t3 = <CognitoFormComponent formData={cognitoForm} prefillData={prefillData} setLoading={setLoading} setError={setError} setErrorText={setErrorText} loading={loading} startTrial={startTrial} accessToken={accessToken} productData={productData} partnerPage={partnerPage} trialIdFromAPI={trialIdFromAPI} />;
    $[4] = accessToken;
    $[5] = cognitoForm;
    $[6] = loading;
    $[7] = partnerPage;
    $[8] = prefillData;
    $[9] = productData;
    $[10] = setError;
    $[11] = setErrorText;
    $[12] = setLoading;
    $[13] = startTrial;
    $[14] = trialIdFromAPI;
    $[15] = t3;
  } else {
    t3 = $[15];
  }
  let t4;
  if ($[16] !== t1 || $[17] !== t2 || $[18] !== t3) {
    t4 = <div className="trial-cognito">{t1}{t2}{t3}</div>;
    $[16] = t1;
    $[17] = t2;
    $[18] = t3;
    $[19] = t4;
  } else {
    t4 = $[19];
  }
  let t5;
  if ($[20] !== trialSummary) {
    t5 = trialSummary && <><TrialSummary content={trialSummary} /></>;
    $[20] = trialSummary;
    $[21] = t5;
  } else {
    t5 = $[21];
  }
  let t6;
  if ($[22] !== t4 || $[23] !== t5) {
    t6 = <section className="bg-gray-m1 w-full p-24"><div className="entitlement-form-container__content-area">{t4}{t5}</div></section>;
    $[22] = t4;
    $[23] = t5;
    $[24] = t6;
  } else {
    t6 = $[24];
  }
  return t6;
};
export default EntitlementsForm;